import * as apis from '@/apis/approval';
import * as actions from '@/actions';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  GET_TRANSFER_LINE_DOC_BY_ID_REQUEST,
  GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST,
  GET_UNMASKING_APPROVAL_REQUEST,
  UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST
} from '../../actions/approval/actionTypes';

function* getTransferLineOrderApproval(reqData) {
  try {
    const result = yield call(apis.getTransferLineOrder, reqData.reqData);
    yield put(actions.getTransferLineOrderApproval.success(result.data));
  } catch (error) {
    yield put(actions.getTransferLineOrderApproval.failure(error));
  }
}

function* getTransferLineDocById(reqData) {
  try {
    const result = yield call(apis.getTransferLineDocById, reqData.reqData);
    yield put(actions.getTransferLineDocById.success(result.data));
  } catch (error) {
    yield put(actions.getTransferLineDocById.failure(error));
  }
}

function* getUnmaskingApproval(reqData) {
  try {
    const result = yield call(apis.getUnmaskingApproval, reqData.reqData);
    yield put(actions.getUnmaskingApproval.success(result.data));
  } catch (error) {
    yield put(actions.getUnmaskingApproval.failure(error));
  }
}

function* updateUnmaskingApprovalStatus(reqData) {
  try {
    const result = yield call(apis.updateUnmaskingApprovalStatus, reqData.reqData);
    yield put(actions.updateUnmaskingApprovalStatus.success(result.data));
  } catch (error) {
    yield put(actions.updateUnmaskingApprovalStatus.failure(error));
  }
}

export default function* approvalSagas() {
  yield takeLatest(GET_TRANSFER_LINE_ORDER_APPROVAL_REQUEST, getTransferLineOrderApproval);
  yield takeLatest(GET_TRANSFER_LINE_DOC_BY_ID_REQUEST, getTransferLineDocById);
  yield takeLatest(GET_UNMASKING_APPROVAL_REQUEST, getUnmaskingApproval);
  yield takeLatest(UPDATE_UNMASKING_APPROVAL_STATUS_REQUEST, updateUnmaskingApprovalStatus);

}
